import React from 'react';
import { Routes, Route, HashRouter } from "react-router-dom";

import Dashboard from './pages/Dashboard';
import Login from './pages/login';
import Order from './pages/Order';
import Addorder from './pages/Addorder';
import ViewOrderDetails from './pages/View_Order_Details';
import AddCutting from './component/order/cutting/AddCutting';
import Customer from './pages/master_Records/Customer';
import Style from './pages/master_Records/Style';
import Colour from './pages/master_Records/Colour';
import Sidebar from './layout/sidebar';
import Marker from './pages/master_Records/Marker';
import RawMaterial from './pages/master_Records/Raw_Material';
import axios from "axios";
import Editorder from './pages/Editorder';
import { SidebarProvider } from './context/SidebarOpenContext';
import Vendor from './pages/master_Records/Vendor';
import Fabric from './pages/master_Records/fabric';
import ViewSubOrderDetails from './pages/View_Sub_Order_Details';
import Staff from './pages/master_Records/Staff';
import Request from './pages/Request';
import Line from './pages/master_Records/Line';
import Boxing from './pages/Boxing';
import AddGroupBoxing from './component/order/boxing/AddGroupBoxing';
import EditGroupBoxing from './component/order/boxing/EditGroupBoxing';
import Billing from './pages/billing';
import BillingPdf from './utils/BillPdf';
import PurchaseBillsPage from './pages/purchasebills';
import IssueEntriesPage from './pages/issues_entries';
import StockUsagePage from './pages/StockUsagePage';
import AllStock from './pages/master_Records/allstock';

function App() {
   localStorage.setItem("url", "https://bestfashions.co.in/garments_api/");
  // localStorage.setItem("url", "http://127.0.0.1:5000");
  return (
    <SidebarProvider>
      <HashRouter>
        <Routes>
          <Route path="/" element={<> <Login />  </>} />
          <Route path="/dashboard" element={<> <Sidebar /> <Dashboard /> </>} />
          <Route path="/order" element={<>   <Sidebar /> <Order />  </>} />
          <Route path="/addorder" element={<> <Sidebar /> <Addorder /> </>} />
          <Route path="/edit_order" element={<> <Sidebar /> <Editorder /> </>} />
          <Route path="/view_order_details" element={<> <Sidebar /> <ViewOrderDetails /> </>} />
          <Route path="/view_sub_order_details" element={<> <Sidebar /> <ViewSubOrderDetails /> </>} />
          <Route path="/add_cutting" element={<> <Sidebar /> <AddCutting /> </>} />
          <Route path="/customer" element={<> <Sidebar /> <Customer /> </>} />
          <Route path="/staff" element={<> <Sidebar /> <Staff /> </>} />
          <Route path="/style" element={<> <Sidebar /> <Style /> </>} />
          <Route path="/colour" element={<> <Sidebar /> <Colour /> </>} />
          <Route path="/marker" element={<> <Sidebar /> <Marker /> </>} />
          <Route path="/rawmaterial" element={<> <Sidebar /> <RawMaterial /> </>} />
          <Route path="/fabric" element={<> <Sidebar /> <Fabric /> </>} />
          <Route path="/allstock" element={<> <Sidebar/> <AllStock /> </>} />
          <Route path="/vendor" element={<> <Sidebar /> <Vendor /> </>} />
          <Route path="/line" element={<> <Sidebar /> <Line /> </>} />
          <Route path="/request" element={<> <Sidebar /> <Request /> </>} />
          <Route path="/boxing" element={<> <Sidebar /> <Boxing /> </>} /> 
          <Route path="/billing" element={<> <Sidebar /> <Billing /> </>} /> 
          <Route path="/stock-usage" element={<> <Sidebar /> <StockUsagePage /> </>} /> 

          {/* <Route path="/purchasebill" element={<> <Sidebar /> <PurchaseBillsPage /> </>} />  */}
          <Route path="/addboxing" element={<> <Sidebar /> <AddGroupBoxing/> </>} /> 
          <Route path="/updateboxing" element={<> <Sidebar /> <EditGroupBoxing/> </>} />  
          <Route path="/billing/print/:order_id" element={<> <BillingPdf /> </>} /> 

        </Routes>
      </HashRouter>
    </SidebarProvider>
  );
};
// axios.defaults.baseURL = "http://127.0.0.1:5000";
axios.defaults.baseURL = "https://bestfashions.co.in/garments_api/";
export default App;
